import angular from 'angular';


import AdvancedRegistrationModalController from './advancedRegistrationModalController';
import AdvancedRegistrationFactory from './advancedRegistrationFactory';

import PersonalInfoController from './personalInfo/personalInfoController';
import QuestionsController from './questions/questionsController';
import SuccessController from './success/successController';
import UploadIdController from './uploadId/uploadIdController';


export default angular.module('app.notificationCenter.modal.templates.advancedRegistration', [])

    .controller('AdvancedRegistrationModalController', AdvancedRegistrationModalController)
    .controller('PersonalInfoController', PersonalInfoController)
    .controller('QuestionsController', QuestionsController)
    .controller('SuccessController', SuccessController)
    .controller('UploadIdController', UploadIdController)
    .factory('AdvancedRegistrationFactory', AdvancedRegistrationFactory)
    .run(($templateCache) => {
        $templateCache.put('app/notificationCenter/modal/templates/advancedRegistration/advancedRegistration.html', require('./advancedRegistration.html')); // eslint-disable-line global-require
        $templateCache.put('app/notificationCenter/modal/templates/advancedRegistration/emailUs/emailUs.html', require('./emailUs/emailUs.html')); // eslint-disable-line global-require
        $templateCache.put('app/notificationCenter/modal/templates/advancedRegistration/emailUs/banned.html', require('./emailUs/banned.html')); // eslint-disable-line global-require
        $templateCache.put('app/notificationCenter/modal/templates/advancedRegistration/personalInfo/personalInfo.html', require('./personalInfo/personalInfo.html')); // eslint-disable-line global-require
        $templateCache.put('app/notificationCenter/modal/templates/advancedRegistration/questions/questions.html', require('./questions/questions.html')); // eslint-disable-line global-require
        $templateCache.put('app/notificationCenter/modal/templates/advancedRegistration/success/success.html', require('./success/success.html')); // eslint-disable-line global-require
        $templateCache.put('app/notificationCenter/modal/templates/advancedRegistration/tryAgain/tryAgain.html', require('./tryAgain/tryAgain.html')); // eslint-disable-line global-require
        $templateCache.put('app/notificationCenter/modal/templates/advancedRegistration/uploadId/uploadId.html', require('./uploadId/uploadId.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/notificationCenter/modal/templates/advancedRegistration/index.js